'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _servicesCore = require('@makerdao/services-core');

var _Currency = require('../../eth/Currency');

var _contracts = require('../../../contracts/contracts');

var _contracts2 = _interopRequireDefault(_contracts);

var _OasisOrder = require('./OasisOrder');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Eth2DaiDirect = function (_PrivateService) {
  (0, _inherits3.default)(Eth2DaiDirect, _PrivateService);

  function Eth2DaiDirect() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'exchange';
    (0, _classCallCheck3.default)(this, Eth2DaiDirect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Eth2DaiDirect.__proto__ || (0, _getPrototypeOf2.default)(Eth2DaiDirect)).call(this, name, ['proxy', 'smartContract', 'token', 'cdp', 'web3', 'transactionManager', 'allowance']));

    _this._slippage = 0.02;
    return _this;
  }

  (0, _createClass3.default)(Eth2DaiDirect, [{
    key: 'sell',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_sell, buy, amount) {
        var proxy, method, sellToken, buyToken, minFillAmount, params, options;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._checkProxy(_sell);

              case 2:
                proxy = _context.sent;
                method = this._setMethod(_sell, buy, 'sellAllAmount', proxy);
                sellToken = _sell === 'ETH' ? 'WETH' : _sell;
                buyToken = buy === 'ETH' ? 'WETH' : buy;
                _context.next = 8;
                return this._minBuyAmount(buyToken, sellToken, amount);

              case 8:
                minFillAmount = _context.sent;
                params = this._buildParams(sellToken, amount, buyToken, minFillAmount, method);
                options = this._buildOptions(amount, _sell, method);

                if (!proxy) {
                  _context.next = 14;
                  break;
                }

                _context.next = 14;
                return this.get('allowance').requireAllowance(sellToken, proxy);

              case 14:
                return _context.abrupt('return', _OasisOrder.OasisSellOrder.build(this._oasisDirect(), method, params, this.get('transactionManager'), buyToken === 'DAI' ? _Currency.DAI : _Currency.WETH, options));

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sell(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return sell;
    }()
  }, {
    key: 'buy',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_buy, sell, amount) {
        var proxy, method, buyToken, sellToken, maxPayAmount, params, options;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._checkProxy(sell);

              case 2:
                proxy = _context2.sent;
                method = this._setMethod(sell, _buy, 'buyAllAmount', proxy);
                buyToken = _buy === 'ETH' ? 'WETH' : _buy;
                sellToken = sell === 'ETH' ? 'WETH' : sell;
                _context2.next = 8;
                return this._maxPayAmount(sellToken, buyToken, amount);

              case 8:
                maxPayAmount = _context2.sent;
                params = this._buildParams(buyToken, amount, sellToken, maxPayAmount, method);
                options = this._buildOptions(amount, sell, method, maxPayAmount);

                if (!proxy) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return this.get('allowance').requireAllowance(sellToken, proxy);

              case 14:
                return _context2.abrupt('return', _OasisOrder.OasisBuyOrder.build(this._oasisDirect(), method, params, this.get('transactionManager'), options));

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function buy(_x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return buy;
    }()
  }, {
    key: 'setSlippageLimit',
    value: function setSlippageLimit(limit) {
      this._slippage = limit;
    }
  }, {
    key: 'getBuyAmount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(buyToken, payToken, sellAmount) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._otc().getBuyAmount(this._getTokenAddress(buyToken), this._getTokenAddress(payToken), this._valueForContract(sellAmount, buyToken));

              case 2:
                this._buyAmount = _context3.sent;
                return _context3.abrupt('return', this._buyAmount);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getBuyAmount(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return getBuyAmount;
    }()
  }, {
    key: 'getPayAmount',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(payToken, buyToken, buyAmount) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._otc().getPayAmount(this._getTokenAddress(payToken), this._getTokenAddress(buyToken), this._valueForContract(buyAmount, buyToken));

              case 2:
                this._payAmount = _context4.sent;
                return _context4.abrupt('return', this._payAmount);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPayAmount(_x11, _x12, _x13) {
        return _ref4.apply(this, arguments);
      }

      return getPayAmount;
    }()
  }, {
    key: '_minBuyAmount',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(buyToken, payToken, payAmount) {
        var buyAmount, adjustedAmount;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this._buyAmount) {
                  _context5.next = 4;
                  break;
                }

                _context5.t0 = this._buyAmount;
                _context5.next = 7;
                break;

              case 4:
                _context5.next = 6;
                return this.getBuyAmount(buyToken, payToken, payAmount);

              case 6:
                _context5.t0 = _context5.sent;

              case 7:
                buyAmount = _context5.t0;
                adjustedAmount = buyAmount * (1 - this._slippage);
                return _context5.abrupt('return', _Currency.ETH.wei(adjustedAmount).toFixed('wei'));

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _minBuyAmount(_x14, _x15, _x16) {
        return _ref5.apply(this, arguments);
      }

      return _minBuyAmount;
    }()
  }, {
    key: '_maxPayAmount',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(payToken, buyToken, buyAmount) {
        var payAmount, adjustedAmount;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this._payAmount) {
                  _context6.next = 4;
                  break;
                }

                _context6.t0 = this._payAmount;
                _context6.next = 7;
                break;

              case 4:
                _context6.next = 6;
                return this.getPayAmount(payToken, buyToken, buyAmount);

              case 6:
                _context6.t0 = _context6.sent;

              case 7:
                payAmount = _context6.t0;
                adjustedAmount = payAmount * (1 + this._slippage);
                return _context6.abrupt('return', _Currency.ETH.wei(adjustedAmount).toFixed('wei'));

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _maxPayAmount(_x17, _x18, _x19) {
        return _ref6.apply(this, arguments);
      }

      return _maxPayAmount;
    }()

    // The only atomic createAndExecute functions that work
    // are payEth orders, because the createAndExecute
    // functions themselves cannot be `payable` with ERC20
    // tokens. _checkProxy is necessary to determine
    // whether a proxy should be built first (as a separate
    // transaction) or if it can be done atomically

  }, {
    key: '_checkProxy',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(sellCurrency) {
        var proxy;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.get('proxy').currentProxy();

              case 2:
                proxy = _context7.sent;

                if (!proxy) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt('return', proxy);

              case 7:
                if (!(sellCurrency !== 'ETH')) {
                  _context7.next = 13;
                  break;
                }

                _context7.next = 10;
                return this.get('proxy').ensureProxy();

              case 10:
                return _context7.abrupt('return', _context7.sent);

              case 13:
                return _context7.abrupt('return', false);

              case 14:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _checkProxy(_x20) {
        return _ref7.apply(this, arguments);
      }

      return _checkProxy;
    }()
  }, {
    key: '_setMethod',
    value: function _setMethod(sellToken, buyToken, method, proxy) {
      if (buyToken === 'ETH') {
        return method += 'BuyEth';
      } else if (sellToken === 'ETH' && !proxy) {
        return 'createAnd' + method.charAt(0).toUpperCase() + method.slice(1) + 'PayEth';
      } else if (sellToken === 'ETH') {
        return method += 'PayEth';
      } else {
        return method;
      }
    }
  }, {
    key: '_buildParams',
    value: function _buildParams(sendToken, amount, buyToken, limit, method) {
      var otcAddress = this._otc().address;
      var daiAddress = this._getTokenAddress('DAI');
      var wethAddress = this._getTokenAddress('WETH');
      var orderAmount = this._valueForContract(amount, sendToken);
      var registryAddress = this.get('smartContract').getContractByName('PROXY_REGISTRY').address;

      switch (method) {
        case 'sellAllAmountPayEth':
          return [otcAddress, wethAddress, daiAddress, limit];
        case 'createAndSellAllAmountPayEth':
          return [registryAddress, otcAddress, daiAddress, limit];
        case 'buyAllAmountPayEth':
          return [otcAddress, daiAddress, orderAmount, wethAddress];
        case 'createAndBuyAllAmountPayEth':
          return [registryAddress, otcAddress, daiAddress, orderAmount];
        default:
          return [otcAddress, this._getTokenAddress(sendToken), orderAmount, this._getTokenAddress(buyToken), limit];
      }
    }
  }, {
    key: '_buildOptions',
    value: function _buildOptions(amount, sellToken, method, maxPayAmount) {
      var options = {};
      options.otc = this._otc();
      if (!method.includes('create')) options.dsProxy = true;
      if (method.toLowerCase().includes('buyallamountpayeth')) {
        options.value = maxPayAmount;
      } else if (sellToken === 'ETH') {
        options.value = this._valueForContract(amount, 'WETH');
      }
      return options;
    }
  }, {
    key: '_getTokenAddress',
    value: function _getTokenAddress(token) {
      return this.get('token').getToken(token).address();
    }
  }, {
    key: '_oasisDirect',
    value: function _oasisDirect() {
      return this.get('smartContract').getContractByName(_contracts2.default.OASIS_PROXY);
    }
  }, {
    key: '_otc',
    value: function _otc() {
      return this.get('smartContract').getContractByName(_contracts2.default.MAKER_OTC);
    }
  }, {
    key: '_valueForContract',
    value: function _valueForContract(amount, symbol) {
      var token = this.get('token').getToken(symbol);
      return (0, _Currency.getCurrency)(amount, token).toFixed('wei');
    }
  }]);
  return Eth2DaiDirect;
}(_servicesCore.PrivateService);

exports.default = Eth2DaiDirect;